/**
 * API Configuration Utils
 * Dynamic API URL detection for Vercel branch deployments
 */

/**
 * Detects if running on a Vercel branch deployment
 * @returns {boolean} True if on a branch deployment
 */
function isVercelBranchDeployment() {
  const hostname = window.location.hostname;
  // Check if hostname contains the Vercel branch deployment pattern
  return hostname.includes('dnd-map-explorer-git-') && hostname.includes('.vercel.app');
}

/**
 * Gets the appropriate API URL based on the environment
 * @returns {string} The API URL to use
 */
export function getApiUrl() {
  // If we have an explicit environment variable, use it (for main production)
  if (process.env.REACT_APP_API_URL && !isVercelBranchDeployment()) {
    return process.env.REACT_APP_API_URL;
  }
  
  // If running on a Vercel branch deployment, use the same domain for API
  if (isVercelBranchDeployment()) {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    return `${protocol}//${hostname}`;
  }
  
  // Default fallback for local development
  return 'http://localhost:5000';
}

/**
 * Gets the API URL with endpoint path
 * @param {string} endpoint - The API endpoint path (e.g., '/api/auth/login')
 * @returns {string} Full API URL with endpoint
 */
export function getApiEndpoint(endpoint = '') {
  const baseUrl = getApiUrl();
  // Ensure endpoint starts with /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${normalizedEndpoint}`;
}

/**
 * Configures axios with the correct base URL
 */
export function configureAxios(axios) {
  axios.defaults.baseURL = getApiUrl();
  
  // Add debug info for development (and production for debugging)
  console.log('🔧 API Configuration:', {
    isVercelBranch: isVercelBranchDeployment(),
    hostname: window.location.hostname,
    apiUrl: getApiUrl(),
    envVar: process.env.REACT_APP_API_URL,
    nodeEnv: process.env.NODE_ENV
  });
}

const apiConfig = {
  getApiUrl,
  getApiEndpoint,
  configureAxios,
  isVercelBranchDeployment
};

export default apiConfig;